import type { CardPrint } from '@/hooks/useCollection';

const TREATMENT_LABELS: Record<string, string> = {
  normal: 'Normal',
  cold_foil: 'Cold Foil',
  holofoil: 'Holofoil',
  rainbow_foil: 'Rainbow Foil',
  inkwash_foil: 'Inkwash Foil',
  glimmer_foil: 'Glimmer Foil',
  iridescent: 'Iridescent',
  enchanted: 'Enchanted',
  epic: 'Epic',
  iconic: 'Iconic',
  promo: 'Promo',
};

export function treatmentLabel(t?: string | null): string {
  if (!t) return 'Normal';
  return TREATMENT_LABELS[t] || t.replace(/_/g, ' ').replace(/\b\w/g, (s) => s.toUpperCase());
}

/** Sort prints with 'normal' first, then by price desc. */
export function sortPrints(prints: CardPrint[]): CardPrint[] {
  return [...prints].sort((a, b) => {
    if (a.treatment === 'normal' && b.treatment !== 'normal') return -1;
    if (b.treatment === 'normal' && a.treatment !== 'normal') return 1;
    return (Number(b.price_usd) || 0) - (Number(a.price_usd) || 0);
  });
}
